/* eslint-disable */
export enum UsageVerificationType {
	VERIFIED = 1,
	NOT_VERIFIED = 2,
	MANUAL_VERIFICATION_NEEDED = 3,
}
/* eslint-enable */
